import ZipCodeEntry from './ZipCodeEntry';
import { shouldShowZipCodeTest } from './zipcodentry.utils';

export { shouldShowZipCodeTest };
export default ZipCodeEntry;
